import { render } from "./TextPage.vue?vue&type=template&id=ce99b398&scoped=true&ts=true"
import script from "./TextPage.ts?vue&type=script&lang=ts"
export * from "./TextPage.ts?vue&type=script&lang=ts"

import "./TextPage.vue?vue&type=style&index=0&id=ce99b398&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce99b398"]])

export default __exports__